import { Typography } from '@mui/material';

export const Heading = ({ text, level, sx, color }) => (
  <Typography
    variant={`h${level}`}
    sx={{
      color,
      ...sx,
    }}
  >
    {text}
  </Typography>
);
